module.exports = __webpack_public_path__ + "static/media/item_2_4.ca378dc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_4.png
// module id = 111
// module chunks = 0